<div class="modal-header justify-content-between">
  <h4 class="fw-bold">Time Off Request</h4>
  <div>
    <button type="button" class="close ms-3" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<div
  class="modal-body"
  *ngIf="form != null"
  [formGroup]="form"
  ngxsForm="timeOffRequests.NewRequestForm">
  <div class="row">
    <div class="col-7">
      <div class="row">
        <div class="col-12">
          <label class="fw-bold">Employee</label>
          <ng-template #employeeTemplate let-r="result" let-t="term">
            <ngb-highlight [result]="r.FirstName + ' ' + r.LastName" [term]="t"></ngb-highlight>
          </ng-template>
          <div class="input-group">
            <input
              class="form-control h-100"
              [class.typeahead-arrow]="
                form.get('employee').value == '' || form.get('employee').value == null
              "
              [class.me-0]="form.get('employee').value != '' && form.get('employee').value != null"
              [class.pe-0]="form.get('employee').value != '' && form.get('employee').value != null"
              [class.border-end-0]="
                form.get('employee').value != '' && form.get('employee').value != null
              "
              type="text"
              formControlName="employee"
              [ngbTypeahead]="search"
              [inputFormatter]="formatter"
              [resultTemplate]="employeeTemplate"
              (focus)="focus$.next($any($event).target.value)"
              (click)="click$.next($any($event).target.value)"
              #typeahead="ngbTypeahead" />
            <button
              class="input-group-append text-danger ps-2"
              (click)="clearEmployee()"
              *ngIf="form.get('employee').value != '' && form.get('employee').value != null">
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label for="timeOffType" class="fw-bold">Time Off Type</label>
          <select class="form-control" formControlName="timeOffType" id="timeOffType">
            <option disabled></option>
            <option *ngFor="let plan of displayPtos" [ngValue]="plan.Id">{{ plan.Name }}</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label for="requestType" class="fw-bold">Request Type</label>
          <select class="form-control" formControlName="requestType" id="requestType">
            <option [ngValue]="RequestTypes.PartialDay">Partial Day</option>
            <option [ngValue]="RequestTypes.SingleDay">Single Day</option>
            <option [ngValue]="RequestTypes.MultipleDays">Multiple Days</option>
          </select>
        </div>
      </div>
      <div class="row" *ngIf="form.get('requestType').value == RequestTypes.SingleDay">
        <div class="col-12">
          <label for="singleDayDate" class="fw-bold">Date</label>
          <div class="input-group">
            <input
              formControlName="startDate"
              class="form-control datepicker"
              ngbDatepicker
              id="singleDayDate"
              #d="ngbDatepicker"
              [firstDayOfWeek]="7"
              [minDate]="{ year: 1900, month: 1, day: 1 }"
              [placement]="['bottom-end', 'top-end']" />
            <img src="assets/icons/calendar.svg" (click)="d.toggle()" class="icon-append" />
          </div>
          <small class="form-text" *ngIf="showPeriodStartDateWarning | async">
            <i
              class="fas fa-exclamation-triangle"
              style="border-radius: 30px; padding: 8px; background-color: #ffc113; color: #fff">
            </i>
            The requested time off falls in a prior pay period and will NOT be automatically entered
            with the next payroll. If this time needs to be recorded, please enter the hours
            manually or contact ConnectPay to assist you
          </small>
        </div>
        <div class="col-12">
          <label for="singleDayHours" class="fw-bold">Hours</label>
          <input
            appNumberInput
            [decimals]="2"
            formControlName="hours"
            type="number"
            class="form-control"
            id="singleDayHours"
            step="0.01" />
          <span *ngIf="form.get('hours').errors?.max" class="text-danger">
            You cannot request more than 24 hours in a single day.
          </span>
          <span *ngIf="form.get('hours').errors?.min" class="text-danger">
            You cannot request less than 1 hour in a single day.
          </span>
        </div>
      </div>
      <div class="row" *ngIf="form.get('requestType').value == RequestTypes.PartialDay">
        <div class="col-12">
          <label for="partialDayDate" class="fw-bold">Date</label>
          <div class="input-group">
            <input
              formControlName="startDate"
              class="form-control datepicker"
              ngbDatepicker
              id="partialDayDate"
              #d="ngbDatepicker"
              [firstDayOfWeek]="7"
              [minDate]="{ year: 1900, month: 1, day: 1 }"
              [placement]="['bottom-end', 'top-end']" />
            <img src="assets/icons/calendar.svg" (click)="d.toggle()" class="icon-append" />
          </div>
          <small class="form-text" *ngIf="showPeriodStartDateWarning | async">
            <i
              class="fas fa-exclamation-triangle"
              style="border-radius: 30px; padding: 8px; background-color: #ffc113; color: #fff">
            </i>
            The requested time off falls in a prior pay period and will NOT be automatically entered
            with the next payroll. If this time needs to be recorded, please enter the hours
            manually or contact ConnectPay to assist you
          </small>
        </div>
        <div class="col-6">
          <label for="startTime" class="fw-bold">Start Time</label>
          <lib-timepicker formControlName="startTime" id="startTime"></lib-timepicker>
        </div>
        <div class="col-6">
          <label for="endTime" class="fw-bold">End Time</label>
          <lib-timepicker formControlName="endTime" id="endTime"></lib-timepicker>
        </div>
        <div class="col-12" *ngIf="form.errors?.timeRange || form.errors?.timeRangeNotEqual">
          <span class="text-danger">End Time must be greater than Start Time.</span>
        </div>
        <div class="col-12">
          <span class="fw-bold">Hours</span><br />
          <span>{{ partialDayHours | number: '1.2' }}</span>
        </div>
      </div>
      <div class="row" *ngIf="form.get('requestType').value == RequestTypes.MultipleDays">
        <div class="col-12">
          <label class="fw-bold">Dates</label>
          <lib-date-range-picker
            [firstDayOfWeek]="7"
            [skipHelpers]="true"
            formControlName="dateRange"></lib-date-range-picker>
          <small *ngIf="form.get('dateRange').errors?.invalidDateRange" class="text-danger"
            >Start date must be before end date.</small
          >
          <small class="form-text" *ngIf="showPeriodStartDateWarning | async">
            <i
              class="fas fa-exclamation-triangle"
              style="border-radius: 30px; padding: 8px; background-color: #ffc113; color: #fff">
            </i>
            The requested time off falls in a prior pay period and will NOT be automatically entered
            with the next payroll. If this time needs to be recorded, please enter the hours
            manually or contact ConnectPay to assist you
          </small>
        </div>
        <div class="col-12">
          <label for="multiDayHours">Hours Per Day</label>
          <input
            appNumberInput
            [decimals]="2"
            formControlName="hours"
            type="number"
            class="form-control"
            id="multiDayHours" />
          <span *ngIf="form.get('hours').errors?.max" class="text-danger">
            You cannot request more than 24 hours in a single day.
          </span>
          <span *ngIf="form.get('hours').errors?.min" class="text-danger">
            You cannot request less than 1 hour in a single day.
          </span>
        </div>
      </div>
    </div>
    <div class="col-5">
      <lib-hours-display
        *ngIf="showHoursDisplay"
        [currentRequestHoursObs]="currentRequestHoursObs"
        [planId]="chosenPlanIdObs"
        [personId]="form.get('employee').value.Id"></lib-hours-display>
    </div>
  </div>
  <div class="row mt-1">
    <div class="col-12">
      <label class="fw-bold">Employer Comments:</label>
      <textarea class="form-control" formControlName="employeeComments"></textarea>
    </div>
  </div>
  <div class="row mt-1">
    <span *ngIf="isWeekend()" class="text-danger">Your selected days include weekends.</span>
    <span *ngIf="showHolidayMessage" class="text-danger">Your selected days include holidays.</span>
    <span
      *ngIf="form != null && (balanceIsNegative | async) && negativeBalanceAllow"
      class="text-danger"
      >*You are submitting a time off request that exceeds your available balance.</span
    >
    <span
      *ngIf="form != null && (balanceIsNegative | async) && !negativeBalanceAllow"
      class="text-danger"
      >*You cannot submit a time off request that exceeds your available balance.</span
    >
  </div>
</div>
<div class="modal-footer text-right" *ngIf="form != null">
  <button class="btn btn-secondary" (click)="closeModal()">Cancel</button>
  <button
    class="btn btn-primary ms-3"
    [disabled]="
      form.untouched || form.invalid || ((balanceIsNegative | async) && !negativeBalanceAllow)
    "
    (click)="submitForm()">
    Submit
  </button>
</div>
